import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { Row } from "antd";
import PageImagePicker from "components/AdminBooks/AnswerPagePicker";
import { DeleteModal } from "components/Dialog";
import React, { useRef, useState } from "react";
import styled from "styled-components";


const AnswerModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px; 
    @media only screen and (max-width: 600px) {
        min-width: 90% !important;
    }
`;

const TitleText = styled.span`
    font-size: 18px;
    color: black;
    font-weight:600;
    // margin-left:5px;
    // margin-top:5px;
`;

const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
  ::-webkit-scrollbar {
    width: 5px;
    height: 3px;
  }
  scroll-behavior: smooth;
`;

const AnswerModal = ({ onCloseDrawer, pageId, onRemove, data, onChangeDesc, onChangeImage, title, setUpdateLoader, updateLoader, errorImg, setErrorImg, loaderImg, setLoaderImg, actionButtonText }) => {
  const [deleteModal, setDeleteModal] = useState(false);
  const innerRef = useRef(null);


  const onAutoScroll = () => {
    if (innerRef.current) {
      setTimeout(() => {
        innerRef.current.scrollTo(0, innerRef.current.scrollHeight)
      }, 500)
    }
  }
  return (
    <>
      <DeleteModal deleteToggle={deleteModal} onDelete={() => {
        onCloseDrawer();
        onRemove(data);
      }}
        setDeleteToggle={setDeleteModal}
        message={`Are you sure you want to remove "${title}" on pageId ${pageId}?`}
      />
      <AnswerModalContent style={{ width: "60vw" }}>
        <Row style={{ justifyContent: "space-between" }}>
          <TitleText>{title}</TitleText>
          <IconButton
            onClick={() => onCloseDrawer()}
            style={{ padding: 0, marginRight: 10 }}
          >
            <Close color="secondary" />
          </IconButton>
        </Row>
        <ModalConfigArea ref={innerRef}>
          <PageImagePicker
            onChange={onChangeImage}
            pageId={pageId}
            data={data}
            onDelete={(data, index) => {
              // onCloseDrawer();
              onRemove(data, index);
            }}
            comeFrom={'resource'}
            onAutoScroll={onAutoScroll}
            setUpdateLoader={setUpdateLoader}
            updateLoader={updateLoader}
            errorImg={errorImg}
            setErrorImg={setErrorImg}
            loaderImg={loaderImg}
            setLoaderImg={setLoaderImg}
            actionButtonText={actionButtonText}
          />
        </ModalConfigArea>
      </AnswerModalContent>
    </>
  )
}

export default AnswerModal;